import styled from "styled-components";

const PageContainer = styled.main`
  height: 100vh;
`;

export default PageContainer;
